// src/components/strumenti/ConversioneKvaKw.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConversioneKvaKw() {
  const [valore, setValore] = useState("");
  const [cosphi, setCosphi] = useState("0.9");
  const [modo, setModo] = useState("kva_kw");

  const v = leggiNumero(valore)||0;
  const cf = leggiNumero(cosphi)||1;
  const risultato = modo==="kva_kw" ? v*cf : (cf>0 ? v/cf : null);

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("kva_kw");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="kva_kw"?"#7c3aed":"#e5e7eb"}`, background: modo==="kva_kw"?"#faf5ff":"#fff", color: modo==="kva_kw"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>kVA → kW</button>
        <button onClick={()=>{setModo("kw_kva");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="kw_kva"?"#7c3aed":"#e5e7eb"}`, background: modo==="kw_kva"?"#faf5ff":"#fff", color: modo==="kw_kva"?"#7c3aed":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>kW → kVA</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>{modo==="kva_kw" ? "Potenza apparente (kVA)" : "Potenza attiva (kW)"}</label>
          <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
        <div>
          <label style={lbl}>cos φ</label>
          <input value={cosphi} onChange={e=>setCosphi(e.target.value)} style={inp}/>
        </div>
      </div>

      {(cf > 1 || cf <= 0) && <div role="alert" style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"7px 10px", marginBottom:10, fontSize:11, color:"#991b1b" }}>Il cos φ deve essere tra 0 e 1: controlla il valore scritto.</div>}
      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{modo==="kva_kw" ? "Potenza attiva" : "Potenza apparente"}</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#7c3aed" }}>
          {risultato===null || isNaN(risultato) ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:2})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="kva_kw" ? "kW" : "kVA"}</span>
        </div>
      </div>

      <button onClick={()=>{setValore("");setCosphi("0.9");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
